import { render, staticRenderFns } from "./goodslist.vue?vue&type=template&id=8bb1dd22&scoped=true"
import script from "./goodslist.vue?vue&type=script&lang=js"
export * from "./goodslist.vue?vue&type=script&lang=js"
import style0 from "./goodslist.vue?vue&type=style&index=0&id=8bb1dd22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb1dd22",
  null
  
)

export default component.exports